import { APPS } from '@constants/navigation';
import { alpha, Grid2 } from '@mui/material';

export const AppsGrid = () => (
    <Grid2
        container
        direction="row"
        p={{ xs: 0, md: '10px' }}
        rowSpacing={{ xs: 0, md: '20px' }}
        columnSpacing={{ xs: 0, md: '15px' }}
        width={{ xs: '100%', md: 500 }}
    >
        {APPS.map((app) => (
            <Grid2
                size={{
                    xs: 6,
                    md: 4,
                }}
                key={`app-${app.label}`}
                component="a"
                href={app.href}
                target="_blank"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                py="6px"
                borderRadius="6px"
                sx={{
                    '&:hover': {
                        backgroundColor: alpha('#000', 0.04),
                    },
                }}
            >
                <app.icon style={{ marginBottom: '8px' }} />
                {app.label}
            </Grid2>
        ))}
    </Grid2>
);
